"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadTranslator = loadTranslator;
var _actions = require("../dragon/store/loader/actions");
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
var _logger = _interopRequireDefault(require("./logger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function loadTranslator(locale, language) {
  var config = _Core["default"].getState().config;
  if (!config.tUrl) {
    _logger["default"].warn("No tUrl configured, cannot load translations from translator.");
    return;
  }
  var url = config.tUrl;
  url = url.replace('{iid}', config.iId.toString()).replace('{gid}', config.gameId).replace('{locale}', language).replace('{ctx}', config.context).replace('{brand}', config.brand);
  _Core["default"].dispatch((0, _actions.load)(url, "language_translator_" + language, {
    languageFile: true
  }));
}
//# sourceMappingURL=loadTranslator.js.map